(function(w,d,$){
  'use strict';
  if (!$) return;

  var A = w.AT_Main = w.AT_Main || {};

  A.getWidthBrowser = function(){
    return w.innerWidth || (d.documentElement && d.documentElement.clientWidth) || (d.body && d.body.clientWidth) || 0;
  };

  A.checkLayout = function(){
    if ($('#checkLayout .visible-xs-block').css('display') === 'block') return 1;
    if ($('#checkLayout .visible-sm-block').css('display') === 'block') return 2;
    if ($('#checkLayout .visible-md-block').css('display') === 'block') return 3;
    if ($('#checkLayout .visible-lg-block').css('display') === 'block') return 4;
  };

  A.fixNoScroll = function(){
    var width = $(w).width();
    $('#page-body, .header-content, #page-body .mobile-version').css('width', width + 'px');
  };

  A.fixReturnScroll = function(){
    $('#page-body, .header-content, #page-body .mobile-version').attr('style', '');
  };

  A.toTopButton = function(){
    var button = $('#scroll-to-top');
    if (!button.length) return;
    var ticking = false;
    function update(){
      var top = w.pageYOffset || d.documentElement.scrollTop || 0;
      var height = w.innerHeight || d.documentElement.clientHeight || 0;
      var marker = top > 100 ? top + height / 2 : 1;
      button.removeClass('on off').addClass(marker < 1000 && marker < height ? 'off' : 'on');
    }
    function onScroll(){
      if (ticking) return;
      ticking = true;
      (w.requestAnimationFrame || function(cb){ return w.setTimeout(cb,16); })(function(){ update(); ticking = false; });
    }
    w.addEventListener('scroll', onScroll, { passive: true });
    update();
    button.on('click.iceHome', function(e){
      e.preventDefault();
      $('body,html').animate({scrollTop:0},800,'swing');
    });
  };

  A.effectNavigation = function(){
    $('.horizontal-menu .navigation .navbar-collapse .main-nav>li').hover(function(){
      $(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').addClass('fadeInUp animated');
    },function(){
      $(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').removeClass('fadeInUp animated');
    });
    $('.verticle-menu .navigation .navbar-collapse .main-nav>li').hover(function(){
      $(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').addClass('fadeInRight animated');
    },function(){
      $(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').removeClass('fadeInRight animated');
    });
    $('.cart-target').hover(function(){
      $(this).find('>.dropdown-menu').addClass('fadeInUp animated');
    },function(){
      $(this).find('>.dropdown-menu').removeClass('fadeInUp animated');
    });
  };

  A.menuOnMobile = function(){
    $('#page-body').on('click.iceHomeMenu', function(){
      $('.menu-mobile').removeClass('opened');
      $('html,body').removeClass('menu-opened');
      A.fixReturnScroll();
    });
    $(d).on('click.iceHomeMenu','[data-toggle=offcanvas]',function(e){
      e.stopPropagation();
      A.fixNoScroll();
      $('.menu-mobile').toggleClass('opened');
      $('html,body').toggleClass('menu-opened');
    });
    $('.navbar .main-nav li').hover(function(){ $(this).addClass('hover'); }, function(){ $(this).removeClass('hover'); });
    $(d).on('click.iceHomeMenu','.mobile-version .menu-mobile .main-nav .expand',function(){
      var parent = $(this).parents('.dropdown').first();
      if (parent.hasClass('menu-mobile-open')) {
        parent.removeClass('menu-mobile-open');
        $(this).find('.visible-xs').removeClass('fa-minus').addClass('fa-plus');
      } else {
        parent.addClass('menu-mobile-open');
        $(this).find('.visible-xs').removeClass('fa-plus').addClass('fa-minus');
      }
    });
  };

  A.handleMenuMultiLine = function(){
    var outItem = '', down = false;
    $('.navbar-collapse .main-nav > li').on('mousemove.iceHomeMenu', function(e){
      var target = $(e.currentTarget);
      if (down && outItem !== '') {
        outItem.addClass('hold');
        w.setTimeout(function(){
          if (outItem !== '') outItem.removeClass('hold');
          down = false;
          outItem = '';
        },500);
        if (outItem[0] === target[0] || outItem.offset().top === target.offset().top) {
          outItem.removeClass('hold');
          down = false;
          outItem = '';
        }
      } else {
        outItem = '';
      }
    });
    $('.navbar-collapse .main-nav > li').on('mouseout.iceHomeMenu', function(e){
      var target = $(e.currentTarget);
      if (e.pageY >= target.offset().top + 50) down = true;
      if (target.hasClass('dropdown') && outItem === '') outItem = target;
    });
  };

  A.cartJS_handle = function(){
    $(d).on('cart.requestComplete.iceHome', function(event, cart){
      if (w.Shopify && typeof w.Shopify.onCartUpdate === 'function') {
        w.Shopify.onCartUpdate(cart || (w.CartJS && w.CartJS.cart) || {});
      }
    });
  };

  A.init = function(){
    A.toTopButton();
    A.effectNavigation();
    A.menuOnMobile();
    A.handleMenuMultiLine();
    A.cartJS_handle();
  };

  w.addEventListener('resize', function(){
    if (A.getWidthBrowser() < 1024 && $('#top').hasClass('on')) {
      $('#top').prev().remove();
      $('#top').removeClass('on animated');
    }
    A.fixReturnScroll();
    if (A.checkLayout() !== 1 && $('.menu-mobile').hasClass('opened')) $('#page-body').trigger('click');
  }, { passive: true });

  $(function(){
    A.init();
    $('form#search').on('submit.iceHome', function(){
      var input = $('#input-ajax-search');
      var value = input.val() || '';
      if (value && value.slice(-1) !== '*') input.val(value + '*');
    });
  });
}(window,document,window.jQuery));
